import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/kit";
import { Skeleton } from "@/components/ui/skeleton";
import { WelcomeCertificate } from "@/components/WelcomeCertificate";

export default function Certificates() {
  const { user } = useAuth();
  const isEmployee = user?.role === "employee";

  const { data: allEmployees = [], isLoading } = useQuery({
    queryKey: ["employees"],
    queryFn: async () => (await api.get("/employees")).data,
  });

  const employees = isEmployee
    ? allEmployees.filter((e) => e.employee_id === user?.employee_id)
    : allEmployees;

  return (
    <div data-testid="certificates-page">
      <PageHeader
        title={isEmployee ? "My Welcome Certificate" : "Welcome Certificates"}
        subtitle={isEmployee ? "Your official VNS Vinayaka welcome certificate — print or download" : "Branded welcome certificates for the team — print or download"}
      />

      {isLoading ? (
        <div className="space-y-8">{[1, 2].map((i) => <Skeleton key={i} className="h-[537px] rounded-lg" />)}</div>
      ) : employees.length === 0 ? (
        <p className="py-16 text-center text-slate-400">
          {isEmployee ? "Your certificate isn't ready yet. Please contact your Head." : "No employees found. Add employees in Employee Master first."}
        </p>
      ) : (
        <div className="space-y-12">
          {employees.map((e) => (
            <div key={e.employee_id} className="w-full overflow-x-auto flex justify-center">
              <WelcomeCertificate employee={e} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
